module.exports = __webpack_public_path__ + "img/benefits-22.6ee7d5df.svg";